module.exports = __webpack_public_path__ + "4df9e0b4b291ea0e9cee942e741606d0.jpg";